import {driver} from "driver.js";
import "driver.js/dist/driver.css";

window.FacetTrak = window.FacetTrak || {};
window.FacetTrak.functions = window.FacetTrak.functions || {};

let completedTour = $('meta[name="tour-completed"]').attr('content');

const tours = {
    mainTour: [
        {
            popover: {
                title: 'Welcome',
                description: 'Welcome to FacetTrak! This is a simple tour to <strong>show</strong> you how to navigate system',
            }
        },
        {
            element: '#main-sidebar',
            popover: {
                title: 'Navigation',
                description: 'This is the side navigation menu where all links for the pages that you have access to reside.',
                side: "right",
                align: 'center'
            }
        },
        {
            element: '#ticketNavList',
            popover: {
                title: 'Navigation',
                description: 'You can click on these tabs to show the respective category\'s page. Go ahead and give it a click',
                side: "bottom",
                align: 'start'
            }
        },
        {
            element: 'ul[data-parent=\'tickets\'] li:nth-child(1)',
            popover: {
                title: 'Pages',
                description: 'Here are all the ticket pages that you have access to. You can click any of them to view the page. ' +
                    'You can also hover over the link to see a \'Favorite\' button. Clicking this button will add the page to your favorites.',
                side: "left",
                align: 'start'
            }
        },
        {
            element: '#siteSearchListing',
            popover: {
                title: 'Navbar Search',
                description: 'At the top of the page, you can find the search bar. ' +
                    'You can use it to search for tickets by customer first name, last name,' +
                    ' company name, ticket number, phone number, email address, or description',
                side: "top",
                align: 'start'
            }
        },
        {
            element: '#assigned-tickets-dropdown',
            popover: {
                title: 'Assigned Tickets',
                description: 'This dropdown lists all open tickets that are assigned to you.',
                side: "right",
                align: 'start'
            }
        },
        {
            element: '#notification-dropdown',
            popover: {
                title: 'Notifications',
                description: 'Notifications will be displayed under this dropdown. ' +
                    'System notifications can be for assigned tickets, subscriptions, and much more. ' +
                    'You can also view all previous notifications in your user profile.'
            }
        },
        {
            element: '#status-dropdown',
            popover: {
                title: 'Employee Status',
                description: 'This is where you can change your status as an employee.' +
                    ' Statuses are used for the dispatch dashboard. ' +
                    'It also shows how many hours you have worked today.'
            }
        },
        {
            element: '#profile-dropdown',
            popover: {
                title: 'Logout',
                description: 'You can logout here.'
            }
        },
        {
            element: '#documentation-dropdown',
            popover: {
                title: 'Documentation',
                description: 'Helpful documentation can be found for several features included for your installation of FacetTrak.'
            }
        },
        {
            popover: {
                title: 'Explore!',
                description: 'Go ahead and explore what FacetTrak can do for you! ' +
                    'Look out for any <i class="bi bi-question-circle"></i> icons for more help!'
            }
        }
    ],
    dashboardModuleTour: [
        {
            popover: {
                title: 'Module Builder',
                description: 'Welcome to the module builder! This is where you can create custom modules for your dashboard.',
                side: "right",
                align: 'center'
            }
        },
        {
            element: ".module-type-row",
            popover: {
                title: 'Module Type',
                description: 'This field is for determining how the data is displayed.',
                side: "right",
                align: 'center'
            }
        },
        {
            element: ".module-data-row",
            popover: {
                title: 'Module Data',
                description: 'Module data can be selected here. ' +
                    'The module data is the type of data that you want to display.',
                side: "right",
                align: 'center'
            }
        },
        {
            element: ".module-group-row",
            popover: {
                title: 'Grouping',
                description: 'Module grouping lets you select a data field to group the data by. ' +
                    'Eg. Grouping by the ticket type for a count will show a count of each ticket type.',
                side: "right",
                align: 'center'
            }
        },
        {
            element: ".module-range-row",
            popover: {
                title: 'Range',
                description: 'The range, similar to grouping, combines similar dates into one. ' +
                    'Eg. Selecting the range field as a ticket\'s opened date with the period ' +
                    'of daily for a line graph will show the opened tickets with each of the points ' +
                    'being a different day.',
                side: "right",
                align: 'center'
            }
        },
        {
            element: ".expr-container",
            popover: {
                title: 'Expressions',
                description: 'Expressions are used to manipulate the data. You can' +
                    ' filter the data by selecting a field and value to be filtered by.' +
                    ' Eg, filtering by ticket status of open will only show open tickets. ' +
                    'You can add multiple filters.',
                side: "right",
                align: 'center'
            }
        },
    ],
    customReportTour: [
        {
            popover: {
                title: 'Custom Reports',
                description: 'Custom reports can generate simple reports with custom filtering easily. Let\'s get started!',
                side: "right",
                align: 'center'
            }
        },
        {
            element: "#object-select",
            popover: {
                title: 'Select the Data Type',
                description: 'You can first select the type of data you would like to display in the report.',
                side: "right",
                align: 'center'
            }
        },
        {
            element: "#add-join",
            popover: {
                title: 'Extra Data',
                description: 'If you\'d like to display any data that doesn\'t ' +
                    'being to the data you selected, you can choose the related data ' +
                    'by clicking on this button.',
                side: "right",
                align: 'center'
            }
        },
        {
            element: ".extra-container",
            popover: {
                title: 'Report Fields',
                description: 'Select the field. This will show up in the filtering capabilities.',
                side: "right",
                align: 'center',
                onNextClick: (element, step, options) => {
                    // Close the modal
                    $("#selectExtraData").modal('hide');
                },
            }
        },
        {
            element: "#fields-container",
            popover: {
                title: 'Filters',
                description: 'The filterable fields show up as filters before running the report. You can then select these before running the report.',
                side: "right",
                align: 'center'
            }
        },
        {
            element: "#expressions-container",
            popover: {
                title: 'Filters',
                description: 'The custom filtering filters the results every time the report is ran.',
                side: "right",
                align: 'center'
            }
        },
        {
            element: "#selectHeadersButton",
            popover: {
                title: 'Headers',
                description: 'Extra fields related to the selected data type can be selected' +
                    ' to appear in the header of the report.',
                side: "right",
                align: 'top'
            }
        },
        {
            element: ".header-container",
            popover: {
                title: 'Headers',
                description: 'Select any of the listed headers to be displayed in the report.' +
                    ' By default, the listing headers throughout the system will be selected.',
                side: "right",
                align: 'center',
                onNextClick: (element, step, options) => {
                    // Close the modal
                    $("#selectHeaders").modal('hide');
                },
            }
        },
        {
            element: "#view-report",
            popover: {
                title: 'Preview Before Saving',
                description: 'Click Preview Report to see what the results of the report would look like.',
                side: "right",
                align: 'center',
            }
        },
    ],
    projectStageTour: [
        {
            popover: {
                title: 'Project Stages',
                description: 'Project stages can help you organize and track your ' +
                    'projects and tickets with stages and queues. Stages are steps ' +
                    'that a projects goes through, with queues being an individual set ' +
                    'of tasks to complete.',
                side: "right",
                align: 'center'
            }
        },
        {
            element: "#createStageButton",
            popover: {
                title: 'Creating a Stage',
                description: 'Click here to create a new stage.',
                side: "right",
                align: 'center'
            }
        },
        {
            element: ".parent-select-label",
            popover: {
                title: 'Parent Stages',
                description: 'Parent stages are a way of saving templates in case ' +
                    'you use stages multiple times. Select a parent stage to ' +
                    'automatically load the stage\'s details.',
                side: "right",
                align: 'center'
            }
        },
        {
            element: "#createStageInfoTable",
            popover: {
                title: 'Stage Settings',
                description: 'Modify the stage settings here. For the start methods: <br/>' +
                    '<ul>' +
                    '<li><strong>Manual</strong> - Select this option if you want the stage to start on a specific date.</li>' +
                    '<li><strong>Automatic</strong> - Select this option if you want the stage to start immediately or after another stage is completed.</li>' +
                    '</ul>.',
                side: "right",
                align: 'center'
            }
        },
        {
            element: ".queue-container",
            popover: {
                title: 'Stage Queues',
                description: 'Queues are tasks within stages that are made into ' +
                    'tickets when they are started. Each of the settings determines ' +
                    'the information that will be filled out when the ticket is created. ' +
                    'Like the start method of the stage, you can make the queues ' +
                    'start immediately or after another queue within the stage ' +
                    'under the \'Ticket Creation\' selection. The Estimated Duration ' +
                    'is the time that the task should take to ' +
                    'complete and will be reflected on the gantt chart. The notify ' +
                    'section will notify the selected employee(s) when the queue/ticket' +
                    ' has started. The checklists button allows you to automatically attach a checklist ' +
                    'when the queue is started.',
                side: "right",
                align: 'center',
                onNextClick: (element, step, options) => {
                    // Close the modal
                    $("#createStage").modal('hide');
                },
            }
        },
        {
            element: "#stageResyncButton",
            popover: {
                title: 'Re-synching Stages',
                description: 'You resync the stages to recalculate the dates and ' +
                    'clean up the chart if anything happens by clicking this button.',
                side: "right",
                align: 'center'
            }
        },
        {
            element: "#importTemplateButton",
            popover: {
                title: 'Re-synching Stages',
                description: 'You can import multiple stages at once by clicking this button.',
                side: "right",
                align: 'center'
            }
        },
        {
            element: "#gantSideBar",
            popover: {
                title: 'Sidebar',
                description: 'To get a more itemized list of the current project stages, click here.',
                side: "right",
                align: 'center'
            }
        },
        {
            element: "#ganttSideBarColumn",
            popover: {
                title: 'Sidebar',
                description: 'Click on the stage or queue to scroll to it within the ' +
                    'gantt chart. Double click to view the details of the stage/queue. ' +
                    'When a stage or queue is complete, it will be highlighted in green.',
                side: "right",
                align: 'center'
            }
        },
        {
            element: "#ganttViewContainer",
            popover: {
                title: 'Views',
                description: 'Click any of these buttons to change the gantt chart view.',
                side: "right",
                align: 'center'
            }
        },
        {
            element: ".fullscreen-button",
            popover: {
                title: 'Fullscreen',
                description: 'You can also put the gantt chart in fullscreen mode by clicking this button.',
                side: "right",
                align: 'center'
            }
        },
    ],
    dashboardEditTour: [
        {
            element: ".dashboard-modules",
            popover: {
                title: 'Modules',
                description: 'Here you can view the available modules. Drag and drop them onto the grid to add them to your dashboard.',
                side: "right",
                align: 'center'
            }
        },
        {
            element: ".grid-stack",
            popover: {
                title: 'Grid',
                description: 'Drag modules from the right and drop them here to add them to your dashboard. You can also drag them off the grid to remove them.',
                side: "top",
                align: 'center'
            }
        },
        {
            element: ".grid-stack-item",
            popover: {
                title: 'Resize Modules',
                description: 'Use this handle to resize the modules on your dashboard.',
                side: "bottom",
                align: 'end'
            }
        },
        {
            element: "#save-dashboard",
            popover: {
                title: 'Save Dashboard',
                description: 'Click this button to save the positions of the modules on your dashboard.',
                side: "top",
                align: 'center'
            }
        }
    ],
    timesheetTour: [
        {
            element: ".calendar-container",
            popover: {
                title: 'Timesheet Calendar',
                description: 'This is the timesheet calendar where you can view and manage your timesheet entries.',
                side: "top",
                align: 'center'
            }
        },
        {
            element: ".fc-toolbar-chunk",
            popover: {
                title: 'Change Views',
                description: 'Use these buttons to change the calendar view (e.g., day, week, month).',
                side: "top",
                align: 'center'
            }
        },
        {
            element: ".fc-event",
            popover: {
                title: 'Resize and Drag Items',
                description: 'You can resize and drag items in the calendar to adjust their duration and position.',
                side: "top",
                align: 'center'
            }
        },
        {
            element: "#createItemButton",
            popover: {
                title: 'Create Items',
                description: 'Click this button to create a new timesheet item.',
                side: "top",
                align: 'center'
            }
        },
        {
            element: ".fc-event",
            popover: {
                title: 'Edit Items',
                description: 'Click on an existing item to edit it.',
                side: "top",
                align: 'center'
            }
        },
        {
            popover: {
                title: 'Automatic Conversion',
                description: 'Logs are automatically converted into timesheet items.',
                side: "top",
                align: 'center'
            }
        }
    ],
    customerTour: [
        {
            element: ".customer-details",
            popover: {
                title: 'Customer Details',
                description: 'Here you can view the customer\'s details including email, address, and phone numbers.',
                side: "top",
                align: 'center'
            }
        },
        {
            element: ".notes-container",
            popover: {
                title: 'Customer Notes',
                description: 'This section contains any notes related to the customer.',
                side: "top",
                align: 'center'
            }
        },
        {
            element: ".company-details",
            popover: {
                title: 'Company Details',
                description: 'Here you can view the details of the company associated with the customer.',
                side: "top",
                align: 'center'
            }
        },
        {
            element: ".latest-tickets",
            popover: {
                title: 'Latest Tickets',
                description: 'This section shows the latest tickets associated with the customer.',
                side: "top",
                align: 'center'
            }
        },
        {
            element: ".ticket-counts",
            popover: {
                title: 'Total Ticket Counts',
                description: 'Here you can see the total number of tickets associated with the customer.',
                side: "top",
                align: 'center'
            }
        },
        {
            element: ".assigned-projects",
            popover: {
                title: 'Assigned Projects',
                description: 'This section lists the projects assigned to the customer.',
                side: "top",
                align: 'center'
            }
        },
        {
            element: ".bi-eye",
            popover: {
                title: 'Switch to Prospect View',
                description: 'Click this button to switch to the prospect view of the customer.',
                side: "top",
                align: 'center'
            }
        }
    ],
    prospectTour: [
        {
            element: "#prospect-info",
            popover: {
                title: 'Prospect Information',
                description: 'This section contains information about the prospect, including status, type, role, and assigned employee. ' +
                    'You can double click on each of these to edit them.',
                side: "top",
                align: 'center'
            }
        },
        {
            element: ".latest-notes",
            popover: {
                title: 'Latest Notes',
                description: 'Here you can view the latest notes related to the prospect.',
                side: "top",
                align: 'center'
            }
        },
        {
            element: ".follow-up-container",
            popover: {
                title: 'Follow Ups',
                description: 'This section lists the tickets with a follow-up date set for the prospect.',
                side: "top",
                align: 'center'
            }
        }
    ],
    ticketPortalTour: [
        {
            element: '#ticket-id',
            popover: {
                title: 'Ticket ID',
                description: 'This is the unique identifier for your ticket. Please reference this ID when contacting support for any inquiries or updates regarding this ticket.',
                side: 'top',
                align: 'center'
            }
        },
        {
            element: '#ticket-status',
            popover: {
                title: 'Ticket Status',
                description: 'This section displays the current status of your ticket. It helps you track the progress of your issue.',
                side: 'top',
                align: 'center'
            }
        },
        {
            element: '#assigned-technician',
            popover: {
                title: 'Assigned Technician',
                description: 'Here you can see the name of the technician assigned to resolve your issue. You can contact them directly if needed.',
                side: 'top',
                align: 'center'
            }
        },
        {
            element: '#ticket-description',
            popover: {
                title: 'Ticket Description',
                description: 'This section provides a detailed description of the issue you reported.',
                side: 'top',
                align: 'center'
            }
        },
        {
            element: '.notes-section',
            popover: {
                title: 'Technician\'s Notes',
                description: 'Here you can find notes and updates added by the technician working on your ticket.',
                side: 'top',
                align: 'center'
            }
        },
        {
            element: '.your-notes-section',
            popover: {
                title: 'Your Messages',
                description: 'This section contains any additional information or messages you have provided regarding the issue.',
                side: 'top',
                align: 'center'
            }
        },
        {
            element: '.additional-info-group',
            popover: {
                title: 'Add Additional Information',
                description: 'If you have more details to share about the issue, you can add them here. You can also upload relevant attachments to help the technician.',
                side: 'top',
                align: 'center'
            }
        },
        {
            element: '#resolve-ticket',
            popover: {
                title: 'Resolve Ticket',
                description: 'Once your issue is resolved, click this button to mark the ticket as resolved. This will close the ticket and notify the support team.',
                side: 'top',
                align: 'center'
            }
        }
    ]
}

if(completedTour === "0") {
    startTour("mainTour");
}

function finishTour() {
    $.ajax({
        url: route('tenant.tour.complete'),
        method: 'POST',
        success: function() {
            completedTour = "1";
        }
    });
}

window.FacetTrak.functions.startTour = startTour;

/**
 * Starts a tour based on the provided tour name.
 *
 * @param {string} tourName - The name of the tour to start.
 * @returns {object} The driver object used to control the tour.
 */
function startTour(tourName) {
    let config = {
        showProgress: true,
        popoverClass: 'facettrak-popover',
        nextBtnText: 'Next <i class="bi bi-arrow-right"></i>',
        prevBtnText: '<i class="bi bi-arrow-left"></i> Previous',
        doneBtnText: 'Finish <i class="bi bi-check"></i>',
        showButtons: [
            'next',
            'previous',
            'close'
        ]
    }
    if(tourName === "mainTour") {
        let nextClickHandler = function() {
            if(!driverObj.hasNextStep()) {
                finishTour();
            }
            driverObj.moveNext();
        }
        config.onPopoverRender = (popover, {config, state}) => {
            const firstButton = document.createElement("button");
            firstButton.innerText = "I'm an Expert!";
            popover.footerButtons.appendChild(firstButton);
            firstButton.addEventListener("click", () => {
                driverObj.destroy();
                finishTour();
            });
        }
        config.onNextClick = nextClickHandler;
    }
    config.steps = tours[tourName];
    const driverObj = driver(config);
    driverObj.drive();
    return driverObj;
}
